import { SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER } from '../constants/reorder';
import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
const setReorderRequestEmailSentForSupplier = (supplierId) => ({
  type: SEND_REQUEST_REORDER_EMAIL_FOR_SUPPLIER,
  payload: supplierId,
});

export const sendRequestReorderEmailFromSupplier = () => async (dispatch, getState) => {
  const { roles: user, supplier, supplierId } = getState().role;
  const requestReorderUrl = `/suppliers/${supplierId}/request-reorder`;

  const emailData = {
    supplierName: supplier.name,
    userName: `${user.first_name} ${user.last_name}`,
  };
  try {
    const res = await api.post(requestReorderUrl, emailData);
    if (res.data.success) {
      dispatch(alertSuccess('We got your request, our team will contact you within 2 business days'));
      dispatch(setReorderRequestEmailSentForSupplier(supplierId));
    } else dispatch(alertError('Error Sending the Email, please try again later'));
  } catch (e) {
    dispatch(alertError('Error Sending the Email, please try again later'));
  }
};
